import React, { type ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import { SupText } from "../../../components/UI/Text";
import SupX from "../../../icons/X";
import { type CommonColors } from "../../../types/colors";

interface ToastProps {
  color?: CommonColors;
  className?: string;
  icon?: ReactNode;
  title?: string;
  content?: ReactNode;
  actions?: ReactNode;
  onClose?: () => void;
}

const TOAST_COLORS = {
  primary: "bg-primary-25 text-neutral-900 border-0.5 border-primary-500 border-solid",
  info: "bg-info-300 text-info-800 border-0.5 border-solid",
  warning: "bg-warning-300 text-warning-800 border-0.5 border-warning-500 border-solid",
  success: "bg-success-300 text-success-800 border-0.5 border-success-900 border-solid",
  error: "bg-error-300 text-error-925 border-0.5 border-error-500 border-solid",
} as const;

export function SupToast({ color = "primary", className, icon, title, content, actions, onClose }: ToastProps) {
  return (
    <div className={twMerge("sup-toast flex w-fit max-w-md p-4 gap-4 shadow", TOAST_COLORS[color], className)}>
      {Boolean(icon) && <div className="shrink-0 flex justify-center items-center w-10">{icon}</div>}
      <div className="flex flex-1 flex-col justify-center">
        {title && (
          <SupText variant="subtitle1" weight="bold">
            {title}
          </SupText>
        )}
        {typeof content === "string" ? (
          <SupText variant="body2" className="mt-2.5">
            {content}
          </SupText>
        ) : (
          content
        )}
      </div>
      {Boolean(actions) && <div className="shrink-0 flex justify-center items-center">{actions}</div>}
      {Boolean(onClose) && (
        <div className="shrink-0 flex justify-center items-center w-10">
          <button onClick={onClose}>
            <SupX />
          </button>
        </div>
      )}
    </div>
  );
}
